import {VariantPicker, ProductLoader, formatMoney, ProductForm, BuyButtons, CustomButton, SalePrice, CartNotificationDrawer, Drawer, LineItemQuantity} from "//lilycraft.com.au/cdn/shop/t/87/assets/theme.js?v=175124270765260479501778853817"; 
//var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;


/*
*
*
*
** Must check theme.js current active loaded version and must update it at line# of extended-theme.js 
* import {} from "//lilycraft.com.au/cdn/shop/t/77/assets/theme.js?v=175124270765260479501768451399";
* import {} from "//lilycraft.com.au/cdn/shop/t/87/assets/theme.js?v=175124270765260479501778853817"
* 
*
*/




// --
// js/common/product/variant-picker-payment-depricated.js
class VariantPickerPaymnetDepricated extends VariantPicker{
  
  get selectedVariant() {
      let preVarId = this.masterSelector.value
      if(preVarId == null || preVarId == ''){
          //preVarId = document.querySelector("input[id='previousPickedVariant']").value;
      }
      //console.log(' -- preVarId : ', preVarId);
      return this._getVariantById(parseInt(preVarId));
  }
  
  selectVariant(id) {
      //console.log('VariantPickerPaymnet:: Selected Variant ID : ',id);
      if (!this._isVariantSelectable(this._getVariantById(id))) {
        id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
      }
      const previousVariant = this.selectedVariant;
      if (previousVariant && previousVariant.id === id) {
        return;
      }
      
      this.masterSelector.value = id;
      //console.log('VariantPickerPaymnet :: this.masterSelector.value ',  this.masterSelector.value, ' : ', id);
      this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
      if (this.updateUrl && history.replaceState) {
        const newUrl = new URL(window.location.href);
        if (id) {
          newUrl.searchParams.set("variant", id);
        } else {
          newUrl.searchParams.delete("variant");
        }
        window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
      }
      this._updateDisableSelectors();
      this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          product: this.product,
          variant: this.selectedVariant,
          previousVariant
        }
      }));
      if (typeof popCustomPayment === "function"){
        popCustomPayment(this.selectedVariant, 'option1', 100, 'selectVariant');
      }
  }
  _onOptionChanged(event) {
    //console.log(' -- _onOptionChanged --- ',event);
    if (!event.target.name.startsWith("option")) {
      return;
    }
    //console.log("selectVariant ---  ");
    this.selectVariant(this._getVariantFromOptions()?.id);
  }
  
  _onMasterSelectorChanged(event) {
      //console.log('VariantPickerPaymnet:: _onMasterSelectorChanged  : ',event.value);
      if(event.value == '' || event.value == null){
          return;
      }
      const options = this.selectedVariant?.options || [];
      options.forEach((value, index) => {
        let input = this.optionSelectors[index].querySelector(`input[type="radio"][name="option${index + 1}"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
        if (input.tagName === "SELECT" || input.tagName === "INPUT" && input.type === "hidden") {
          triggerChangeEvent = input.value !== value;
          input.value = value;
        } else if (input.tagName === "INPUT" && input.type === "radio") {
          triggerChangeEvent = !input.checked && input.value === value;
          input.checked = input.value === value;
        }
        if (triggerChangeEvent) {
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
  }
  
  _getVariantFromOptions() {
      const options = this._getSelectedOptionValues();
      //console.log('VariantPickerPaymnet :: _getVariantFromOptions ', ' -- options  >>>>>> ', options);
      return this.product["variants"].find((variant) => {
        return variant["options"].every((value, index) => value === options[index]);
      });
  }
  
}

// js/common/product/variant-picker-payment.js
class VariantPickerPaymnet extends VariantPicker{
  
}
if (!window.customElements.get("variant-picker-payment")) {
  window.customElements.define("variant-picker-payment", VariantPickerPaymnet);
}
// --
// --
// [FIX-6 HELPER] _neutraliseExternalSubmitButtons
// Finds every <button type="submit" form="<formId>"> that lives OUTSIDE the form DOM
// (the sticky-bar ATC button in main-product.liquid is rendered inside .sm:hidden which
// is visible on iPhone, and has form= attribute linking it to the product form).
// On iOS Safari, clicking an external submit button causes WebKit to enter its
// "form-associated external submit" algorithm which initiates a multipart POST to
// form.action BEFORE dispatching the submit event — so any submit listener's
// preventDefault() is too late for that network request.
// Solution: change external buttons to type="button" (removes them from the browser's
// implicit submission algorithm entirely), then re-dispatch a cancelable submit event
// from the click handler so _onSubmit still fires normally.
// The data-ext-submit-handled flag prevents double-registration on re-renders.
function _neutraliseExternalSubmitButtons(frm) {
    const formId = frm.getAttribute('id');
    if (!formId) return;
    const externalBtns = document.querySelectorAll(
        `button[type="submit"][form="${CSS.escape(formId)}"]`
    );
    externalBtns.forEach(btn => {
        if (frm.contains(btn)) return;           // skip in-form buttons
        if (btn.dataset.extSubmitHandled) return; // skip already-patched buttons
        btn.dataset.extSubmitHandled = 'true';
        btn.type = 'button';                     // remove from native submit chain
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            // Let _onSubmit decide whether to proceed (it has the #submitting guard)
            frm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
    });
}

// --
// js/common/product/product-form-bundle.js
var ProductFormBundle = class extends HTMLFormElement {
    #submitting = false;
    constructor() {
        super();
        this._gift_wrapper_id = null;
        this._associated_price_addon = "";
        if (window.themeVariables.settings.cartType !== "page" && window.themeVariables.settings.pageType !== "cart") {
            ProductFormRegistered = true;
            this.addEventListener("submit", this._onSubmit);
        }
        //alert("ProductFormBundle Instance");
        console.log("Construct Product-Form-Bundle >>> ProductFormRegistered :", ProductFormRegistered, "|| window.themeVariables.settings.pageType : ", window.themeVariables.settings.pageType);
    }
    
    connectedCallback() {
      this.id.disabled = false;
      // [FIX-6] Block ALL native form POST paths.
      // Neutralize native form POST to /cart/add at custom element upgrade.
      // iOS Safari (no customized-built-in support) + es-module-shims can trigger the
      // browser's native form submission (action="/cart/add") in parallel with the JS
      // submit event, bypassing event.preventDefault() in _onSubmit. That native POST
      // adds the main item WITHOUT gift-wrapper properties, creating a second line item.
      // Overriding form.submit() blocks any programmatic submissions from polyfill internals.
      // Capture-phase listener is the earliest possible hook and fires before bubble listeners.
      if (!this.dataset.nativeSubmitBlocked) {
        this.dataset.nativeSubmitBlocked = 'true';
        this.submit = () => {};  // block form.submit() calls
        this.addEventListener("submit", (e) => e.preventDefault(), { capture: true });
        _neutraliseExternalSubmitButtons(this);
      }
    }
  
    mainQuantity(){
        let qty = 1;
        let mp_pty = document.querySelector('input[name="quantity"][is="quantity-input"]');
        if(mp_pty && mp_pty != null){
          qty = parseInt(mp_pty.value);
          if(qty == null || qty == 0 || qty == 'NaN'){
              let pfrm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
              qty = parseInt(pfrm.quantity.value);
          }
        }
        if(qty == null || qty == 0 || qty == 'NaN'){
          qty = 1;
        }
        return qty;
    }
    
    async addGiftWrapperToCart(variant_id, frm_id){
        let responseJson = null;
        if(window.themeVariables.settings.pageType != 'product' ){
          return responseJson;
        }
        if(frm_id.indexOf('quick-buy-form') !== -1){
            //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>','quick-buy-form' );
            return responseJson;
        }
        let selWrap = document.querySelector('input[type="hidden"][name="selected-wrapper"]');
        if(selWrap != null && selWrap != "" && selWrap.value != ""){
            this._gift_wrapper_id = selWrap.value;
            let formData = new FormData();
            let wqty = this.mainQuantity();
            formData.append('id', selWrap.value);
            formData.append('quantity', wqty);
            formData.append('properties[_for]', variant_id);
            formData.append('utf8', true);
            formData.set("sections", "cart-drawer,variant-added");
            formData.set("sections_url", `${Shopify.routes.root}variants/${selWrap.value}`);
            try {
              const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                  body: formData,
                  method: "POST",
                  headers: {
                    "X-Requested-With": "XMLHttpRequest"
                  }
                });
                responseJson = await response.json();
                //console.log('Gift Wrapper Added to Cart ', responseJson);
            } catch (error) {
                console.log('Error! Gift Wrapper Failed to Add to Cart ', responseJson);
            }              
        }else{
          console.log("No Gift Wrapper is Selected!");
        }
        return responseJson;
    }
  
    async addComplemetaryProductToCart(frm_id, variant_id){
        let responseJson = null;
        //console.log(">>>>>> Check Complementary Product is Selected! -- pageType :  ", window.themeVariables.settings.pageType);
      
        if(window.themeVariables.settings.pageType != 'product' ){
          return responseJson;
        } //else{
            let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
            if(prc && prc != null && prc != 'undefined'){
              try {
                // let addcp = prc.querySelector('.custom-checkbox');
                let cparr = prc.querySelectorAll('.custom-checkbox');
                let cparrCnt = parseInt(cparr.length) ;
                // console.log("addComplemetaryProductToCart  ---- ", cparrCnt, cparr.length, cparr);
                if(cparrCnt > 0){
                  let cpCount = 0;
                  // console.log(" cparrCnt > 0  and cpCount", cpCount,cparrCnt);
                  for(let addcp of cparr){
                    // console.log('Complementary Selector -- ', addcp);
                    if(addcp && addcp != null && addcp.checked == true && addcp.value != ""){
                        let formData = new FormData();
                        let wqty = this.mainQuantity();
                        formData.append('id', addcp.value);
                        formData.append('quantity', wqty);
                        formData.append('properties[_associated]', variant_id);
                        formData.append('utf8', true);
                        let hle = addcp.getAttribute('handle');
                        let pIndex = addcp.getAttribute('pIndx');
                        let addCustom = addcp.getAttribute('personalisation');
                        // console.log(" Handle and Index ", hle, pIndex);
                        if(addCustom == "true" || addCustom == true){
                          let prp = prc.querySelector("."+hle);
                          if(prp && prp != null && prp.value != null && prp.value !=""){
                              formData.append(prp.name, prp.value);
                          }
                        }
                        formData.set("sections", "cart-drawer,variant-added");
                        formData.set("sections_url", `${Shopify.routes.root}variants/${addcp.value}`);
                        try {
                          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                            body: formData,
                            method: "POST",
                            headers: {
                              "X-Requested-With": "XMLHttpRequest"
                            }
                          });
                          responseJson = await response.json();
                          // console.log('Complementary Product Added to Cart ', cpCount, addcp.getAttribute('vpr'), responseJson);
                          if(responseJson != null){
                            if(cpCount > 0){
                              this._associated_price_addon = this._associated_price_addon + ' + ' + addcp.getAttribute('vpr');
                            }else{
                              this._associated_price_addon = addcp.getAttribute('vpr');  
                            }
                            cpCount = cpCount + 1;
                            // console.log("this._associated_price_addon ", this._associated_price_addon, addcp.getAttribute('vpr'));
                          }
                        } catch (error) {
                          console.log('Error! Complementary Product Failed to Added to Cart ', responseJson);
                        }
                    }
                  }
                }
                else{
                    console.log("No Complementary Product is Selected!", cparrCnt);
                }
              } catch (error) {
                console.log("No Complementary Product Selector Found! ", error);
              }
            }
        //}
        return responseJson;
    }
  
    getComplementaryProductPrice(){
        let compProPrice=null;
        let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
        if(prc != null && prc != 'undefined'){
          //let addcp = prc.querySelector('.custom-checkbox');
          let cparr = prc.querySelectorAll('.custom-checkbox');
          // console.log("Get Complementary Product Price   ---- ", cparr.length, cparr);
          if(cparr.length > 0){
            let cpCount = 0;
            for(let addcp of cparr){
              if(addcp && addcp != null && addcp.checked == true && addcp.value != ""){
                if(cpCount > 0){
                  this._associated_price_addon = this._associated_price_addon + ' + ' + addcp.getAttribute('vpr');
                }else{
                  this._associated_price_addon = addcp.getAttribute('vpr');  
                }
                cpCount = cpCount + 1;
                // console.log("this._associated_price_addon ", this._associated_price_addon, addcp.getAttribute('vpr'));
              }
            }
          }
        }
        return compProPrice;
    }
    
    updatePriceInCartDraw(responseJson, gwrap=false, compProPrice=null){
      let wqty = this.mainQuantity();
      // main product price then multiply by quantity
      let pcnt = document.querySelector('.product-info__price');
      let mpText = pcnt.querySelector('sale-price').lastChild.textContent;
      let vidPrice = multiplyWithCurrency(mpText, wqty);
      let updatePriceText = vidPrice;
      
      // Gift wrapper price then multiply by quqntity
      if(gwrap != false){
        let gwpText = document.querySelector('.gift-wrapper-price').innerHTML;  // + $ 
        let wprice = multiplyWithCurrency(gwpText, wqty);; //parseFloat(gwpText.replace('+ $','')) * wqty;
        if(wprice && wprice != 'NaN'){
          updatePriceText = vidPrice + ' + ' + wprice;
          //console.log("updatePriceInCartDraw Gift Wrap --------------- ", gwpText, ' || ', wprice, ' || ',  updatePriceText);
        }else{
           console.log("Error! Unable to resolve Gift Wrapper Price to display in Cart Drawer"); 
        }
      }
      if(compProPrice != null && compProPrice != ""){
        compProPrice = multiplyWithCurrency(compProPrice, wqty);
        updatePriceText = updatePriceText + ' + ' + compProPrice;
      }
      //console.log("Prices IN updatePriceInCartDraw --------------- ", gwrap, compProPrice, ' || ', mpText, vidPrice, updatePriceText);
      
      let variantAdded = responseJson["sections"]['variant-added'];
      let variantAddedUp = variantAdded.replace(vidPrice, updatePriceText);
      responseJson["sections"]['variant-added'] = variantAddedUp;
      //console.log("responseJson[sections] :: updatePriceInCartDraw --------------- ", responseJson["sections"]);
      return responseJson["sections"];
    }
  
    confirmVariant(){
      let pfrm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
      //console.log('_onSubmit >> confirmVariant ----------------- ', pfrm);
      if((pfrm != null && pfrm != 'undefined') && (pfrm.id.value == '' || pfrm.id.value == null)){
          // console.log('_onSubmit ----------------- ', pfrm);
          selMainVarFirstAlert();
          return false;
      }else{
        return true;
      }
    }

    async delay(time=1000) {
      return new Promise(resolve => setTimeout(resolve, time));
    }
    
    async waitAWhile(){
      // console.log('start timer waitAWhile ');
      let delay = await this.delay(1000);
      // console.log('waitAWhile after 1 second');
      return delay;
    }

    async addComplementaryProduct(){
        // console.log('>>>>>>>>>>>>>>>> start addComplementaryProduct ');
        let delay = false;
        let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
        if(prc != null && prc != 'undefined'){
            let addcp = prc.querySelector('.custom-checkbox');
            if (addcp.checked) {
                let btnhcp = prc.querySelector('.btn_hcp');
                btnhcp.click();
                delay = await this.waitAWhile();
            }
        }
        return delay;
    }
    
    async _onSubmit(event) {
        event.preventDefault();
        console.log("ProductFormBundle::_onSubmit triggered!");
        // [FIX-1] Guard: block concurrent submissions (missing in original, present in theme.js ProductForm)
        if (this.#submitting) return;
        if (!this.checkValidity()) {
          this.reportValidity();
          return;
        }
        
        if(!this.confirmVariant()){
          this.reportValidity();
          document.querySelector("button[type='submit'][aria-busy='true']")?.removeAttribute('aria-busy');
          return;
        }
    
        let horizontal = false;  // set it true if User manual action required. then must show Add to cart button against associated product in product info 
        let addWrapResp = null;
        let addCompProResp = null;
        let compProPrice = null;
        let responseJson = null;
        let frm_id = this.getAttribute('id');

        // [FIX-2] Disable buttons BEFORE async side-item fetches so iOS double-tap can't re-enter
        const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
        submitButtons.forEach((submitButton) => {
          submitButton.setAttribute("disabled", "disabled");
          submitButton.setAttribute("aria-busy", "true");
        });
        this.#submitting = true;
    
        // Must has if condition
        if(frm_id.indexOf('product-form') !== -1){
            addCompProResp = await this.addComplemetaryProductToCart(frm_id, this.id.value);
            addWrapResp = await this.addGiftWrapperToCart(this.id.value, frm_id);
            if(addCompProResp != null){
                //console.log("Check Complementary Product Price ", this._associated_price_addon);
                if(this._associated_price_addon == "" || this._associated_price_addon == null){
                  this.getComplementaryProductPrice();
                }
                compProPrice = this._associated_price_addon; // this.getComplementaryProductPrice();
            }else{
                console.log("Error! -- Auto Add to Cart for Complementary Product Failed!");
                //horizontal = true; // Un-comment this. if User manual action required. then must show Add to cart button against associated product in product info
            }
        }    
        let sectionsToBundle = ["variant-added"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
        
        const formData = new FormData(this);
        /*
        const propStartWith = "properties[Add ons";
        for (let [key] of formData.entries()) {
            if (key.startsWith(propStartWith)) {
                formData.delete(key);
            }
        } // */
        if(this._gift_wrapper_id != null){
          formData.set('properties[_has]', this._gift_wrapper_id);  
        }
        formData.set("sections", sectionsToBundle.join(","));
        formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);
        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              body: formData,
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest"
                // Needed for Shopify to check inventory
              }
            });
            if (response.ok) {
              responseJson = await response.json();
              //console.log("Success! Main product added to Cart ", responseJson);
            }else{
                let responseError = await response.json();
                //console.log('Error! add.js response NOT OK Main product item failed to add to cart.....', response, responseJson);
                this.dispatchEvent(new CustomEvent("cart:error", {
                  bubbles: true,
                  detail: {
                    error: responseError["description"]
                  }
                }));
                document.dispatchEvent(new CustomEvent("cart:refresh"));
            }
        } catch (error) {
          console.log('Error! Main product item failed to add to cart.....');
        }
        submitButtons.forEach((submitButton) => {
          submitButton.removeAttribute("disabled");
          submitButton.removeAttribute("aria-busy");
        });
        this.#submitting = false;
        
        // console.log('_________ Main DataForm Response ', responseJson);
        //if (response.ok) {
        if (responseJson != null) {
            if(horizontal == true){
                // console.log('_________ Main Item Added now check Complementary Item !', );
                const addComplementary = await this.addComplementaryProduct();
            }
            if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
              // return window.location.href = `${Shopify.routes.root}cart`;
            }
            try {
                const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();      
                if (addWrapResp != null || this._gift_wrapper_id != null){
                  cartContent["sections"] = this.updatePriceInCartDraw(responseJson, true, compProPrice); //responseJson["sections"]
                  //cartContent["wrapper-section"] = addWrapResp["sections"];
                  // console.log('>>>>> _________ updatePriceInCartDraw ', cartContent);
                }else if(compProPrice != null){
                  cartContent["sections"] = this.updatePriceInCartDraw(responseJson, false, compProPrice); //responseJson["sections"]
                }else{
                  cartContent["sections"] = responseJson["sections"];
                }
                this.dispatchEvent(new CustomEvent("variant:add", {
                  bubbles: true,
                  detail: {
                    items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                    //wrapper : addWrapResp.hasOwnProperty("items") ? addWrapResp["items"] : [addWrapResp],
                    cart: cartContent
                  }
                }));
                try {
                    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                      bubbles: true,
                      detail: {
                        baseEvent: "variant:add",
                        cart: cartContent
                      }
                    }));
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                } catch (error) {
                     //console.log('cart:change event Error ! ', error);
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    //window.location.reload();
                }
                  //window.location.reload();
              } catch (error) {
                  console.log('Error! Cart content update Failed....');
              }
        } else {
            console.log('Error ------- responseJson is null -----');
        }
        return false;
    }
};
if (!window.customElements.get("product-form-bundle")) {
  window.customElements.define("product-form-bundle", ProductFormBundle, { extends: "form" });
}

var ProductFormExt = class extends HTMLFormElement  {
    #submitting = false;
    constructor(){
      super();
        this._gift_wrapper_id = null;
        this._associated_price_addon = "";
        this.frm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
        // [FIX-6] Same native-POST blocker for the iOS fallback path (no polyfill, no custom element upgrade).
        // Applied here in the constructor so it is in place before any submit button can be tapped.
        // Uses data-native-submit-blocked flag so the guard runs only once even if both
        // ProductFormBundle (via polyfill) and ProductFormExt (via fallback) initialise.
        if (this.frm && !this.frm.dataset.nativeSubmitBlocked) {
          this.frm.dataset.nativeSubmitBlocked = 'true';
          this.frm.submit = () => {};  // block form.submit() calls
          this.frm.addEventListener("submit", (e) => e.preventDefault(), { capture: true });
          _neutraliseExternalSubmitButtons(this.frm);
          // [FIX-6b] ProductRerender swaps buy-buttons DOM on variant change (theme.js line 3094).
          // Fresh DOM = new buttons without data-ext-submit-handled → re-run neutraliser.
          this.frm.addEventListener("product:rerender", () => {
            // Yield one microtask so replaceWith() has completed before we query
            Promise.resolve().then(() => _neutraliseExternalSubmitButtons(this.frm));
          });
        }     
        if (window.themeVariables.settings.cartType !== "page" && window.themeVariables.settings.pageType !== "cart") {
            ProductFormRegistered = true;
            // [FIX-3] Store bound reference so it can be removed if needed, and is not duplicated
            this._boundOnSubmit = this._onSubmit.bind(this);
            this.frm.addEventListener("submit", this._boundOnSubmit);
            // [FIX-4] BFCache reset: iOS Safari restores pages from cache and can re-fire submit.
            // Reset submitting flag and re-enable buttons so the restored page is interactive.
            window.addEventListener("pageshow", (event) => {
              if (!event.persisted) return;
              this.#submitting = false;
              const btns = Array.from(this.frm.elements).filter(b => b.type === "submit");
              btns.forEach(b => { b.removeAttribute("disabled"); b.removeAttribute("aria-busy"); });
            });
        }
        alert("ProductFormExt Instance");
        console.log(' ProductFormExt Instace Created with ', this.frm.id.value, this.frm);
    }
  
    connectedCallback() {
      this.frm.id.disabled = false;
    }
    
    async addComplemetaryProductToCart(frm_id, variant_id){
        let responseJson = null;
        // console.log(">>>>>> Check Complementary Product is Selected! -- pageType :  ", window.themeVariables.settings.pageType);
      
        if(window.themeVariables.settings.pageType != 'product' ){
          return responseJson;
        } //else{
            let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
            if(prc && prc != null && prc != 'undefined'){
              try {
                //let addcp = prc.querySelector('.custom-checkbox');
                let cparr = prc.querySelectorAll('.custom-checkbox');
                let cparrCnt = parseInt(cparr.length) ;
                // console.log("addComplemetaryProductToCart  ---- ", cparrCnt, cparr.length, cparr);
                if(cparrCnt > 0){
                  let cpCount = 0;
                  // console.log(" cparrCnt > 0  and cpCount", cpCount,cparrCnt);
                  for(let addcp of cparr){
                    // console.log('Complementary Selector -- ', addcp);
                    if(addcp && addcp != null && addcp.checked == true && addcp.value != ""){
                        let formData = new FormData();
                        let wqty = this.mainQuantity();
                        formData.append('id', addcp.value);
                        formData.append('quantity', wqty);
                        formData.append('properties[_associated]', variant_id);
                        formData.append('utf8', true);
                        let hle = addcp.getAttribute('handle');
                        let pIndex = addcp.getAttribute('pIndx');
                        // console.log(" Handle and Index ", hle, pIndex);
                        if(pIndex != "2" && pIndex != "4"){
                          let prp = prc.querySelector("."+hle);
                          if(prp && prp != null && prp.value != null && prp.value !=""){
                              formData.append(prp.name, prp.value);
                          }
                        }
                        formData.set("sections", "cart-drawer,variant-added");
                        formData.set("sections_url", `${Shopify.routes.root}variants/${addcp.value}`);
                        try {
                          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                            body: formData,
                            method: "POST",
                            headers: {
                              "X-Requested-With": "XMLHttpRequest"
                            }
                          });
                          responseJson = await response.json();
                          // console.log('Complementary Product Added to Cart ', cpCount, addcp.getAttribute('vpr'), responseJson);
                          if(responseJson != null){
                            if(cpCount > 0){
                              this._associated_price_addon = this._associated_price_addon + ' + ' + addcp.getAttribute('vpr');
                            }else{
                              this._associated_price_addon = addcp.getAttribute('vpr');  
                            }
                            cpCount = cpCount + 1;
                            // console.log("this._associated_price_addon ", this._associated_price_addon, addcp.getAttribute('vpr'));
                          }
                        } catch (error) {
                          console.log('Error! Complementary Product Failed to Added to Cart ', responseJson);
                        }
                    }
                  }
                }
                else{
                    console.log("No Complementary Product is Selected!", cparrCnt);
                }
              } catch (error) {
                console.log("No Complementary Product Selector Found! ", error);
              }
            }
        //}
        return responseJson;
    }
  
    getComplementaryProductPrice(){
        let compProPrice=null;
        let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
        if(prc != null && prc != 'undefined'){
          //let addcp = prc.querySelector('.custom-checkbox');
          let cparr = prc.querySelectorAll('.custom-checkbox');
          // console.log("Get Complementary Product Price   ---- ", cparr.length, cparr);
          if(cparr.length > 0){
            let cpCount = 0;
            for(let addcp of cparr){
              if(addcp && addcp != null && addcp.checked == true && addcp.value != ""){
                if(cpCount > 0){
                  this._associated_price_addon = this._associated_price_addon + ' + ' + addcp.getAttribute('vpr');
                }else{
                  this._associated_price_addon = addcp.getAttribute('vpr');  
                }
                cpCount = cpCount + 1;
                // console.log("this._associated_price_addon ", this._associated_price_addon, addcp.getAttribute('vpr'));
              }
            }
          }
        }
        return compProPrice;
    }
  
    async addGiftWrapperToCart(variant_id, frm_id){
        let responseJson = null;
        if(window.themeVariables.settings.pageType != 'product' ){
          return responseJson;
        }
        if(frm_id.indexOf('quick-buy-form') !== -1){
            //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>','quick-buy-form' );
            return responseJson;
        }
        let selWrap = document.querySelector('input[type="hidden"][name="selected-wrapper"]');
        if(selWrap != null && selWrap != "" && selWrap.value != ""){
            this._gift_wrapper_id = selWrap.value;
            let formData = new FormData();
            let wqty = this.mainQuantity();
            formData.append('id', selWrap.value);
            formData.append('quantity', wqty);
            formData.append('properties[_for]', variant_id);
            formData.append('utf8', true);
            formData.set("sections", "cart-drawer,variant-added");
            formData.set("sections_url", `${Shopify.routes.root}variants/${selWrap.value}`);
            try {
              const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                  body: formData,
                  method: "POST",
                  headers: {
                    "X-Requested-With": "XMLHttpRequest"
                  }
                });
                responseJson = await response.json();
                // console.log('Gift Wrapper Added to Cart ', responseJson);
            } catch (error) {
                console.log('Error! Gift Wrapper Failed to Add to Cart ', responseJson);
            }              
        }else{
          console.log("No Gift Wrapper is Selected!");
        }
        return responseJson;
    }
    
    async _onSubmit(event) {
        event.preventDefault();
        console.log("ProductFormExt::_onSubmit triggered!");
        // [FIX-1] Guard: block concurrent submissions (mirrors theme.js ProductForm behaviour)
        if (this.#submitting) return;
        if (!this.frm.checkValidity()) {
          this.frm.reportValidity();
          return;
        }
        
        if(!this.confirmVariant()){
          this.frm.reportValidity();
          document.querySelector("button[type='submit'][aria-busy='true']")?.removeAttribute('aria-busy');
          return;
        }
    
        let horizontal = false;   // set it true if User manual action required. then must show Add to cart button against associated product in product info 
        let addWrapResp = null;
        let addCompProResp = null;
        let compProPrice = null;
        let responseJson = null;
        let frm_id = this.frm.getAttribute('id');

        // [FIX-2] Disable buttons BEFORE async side-item fetches so iOS double-tap can't re-enter
        const submitButtons = Array.from(this.frm.elements).filter((button) => button.type === "submit");
        submitButtons.forEach((submitButton) => {
          submitButton.setAttribute("disabled", "disabled");
          submitButton.setAttribute("aria-busy", "true");
        });
        this.#submitting = true;
    
        // Must has if condition
        if(frm_id.indexOf('product-form') !== -1){
            addCompProResp = await this.addComplemetaryProductToCart(frm_id,this.frm.id.value);
            addWrapResp = await this.addGiftWrapperToCart(this.frm.id.value, frm_id);
            if(addCompProResp != null){
                // console.log("Check Complementary Product Price ", this._associated_price_addon);
                if(this._associated_price_addon == "" || this._associated_price_addon == null){
                  this.getComplementaryProductPrice();
                }
                compProPrice = this._associated_price_addon; // this.getComplementaryProductPrice();
            }else{
                // console.log("Error! -- Auto Add to Cart for Complementary Product Failed!");
                // horizontal = true;   // Un-comment it. true if User manual action required. then must show Add to cart button against associated product in product info 
            }
        }    
        let sectionsToBundle = ["variant-added"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
        
        const formData = new FormData(this.frm);
        const propStartWith = "properties[Add ons";
        for (let [key] of formData.entries()) {
            if (key.startsWith(propStartWith)) {
                formData.delete(key);
            }
        }
        if(this._gift_wrapper_id != null){
          formData.set('properties[_has]', this._gift_wrapper_id);  
        }
        formData.set("sections", sectionsToBundle.join(","));
        formData.set("sections_url", `${Shopify.routes.root}variants/${this.frm.id.value}`);
        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              body: formData,
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest"
                // Needed for Shopify to check inventory
              }
            });
            if (response.ok) {
              responseJson = await response.json();
              //console.log("Success! Main product added to Cart ", responseJson);
            }else{
                let responseError = await response.json();
                //console.log('Error! add.js response NOT OK Main product item failed to add to cart.....', response, responseJson);
                this.dispatchEvent(new CustomEvent("cart:error", {
                  bubbles: true,
                  detail: {
                    error: responseError["description"]
                  }
                }));
                document.dispatchEvent(new CustomEvent("cart:refresh"));
            }
        } catch (error) {
          console.log('Error! Main product item failed to add to cart.....');
        }
        submitButtons.forEach((submitButton) => {
          submitButton.removeAttribute("disabled");
          submitButton.removeAttribute("aria-busy");
        });
        this.#submitting = false;
        
        // console.log('_________ Main DataForm Response ', responseJson);
        //if (response.ok) {
        if (responseJson != null) {
            if(horizontal == true){
                // console.log('_________ Main Item Added now check Complementary Item !', );
                const addComplementary = await this.addComplementaryProduct();
            }
            if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
              // return window.location.href = `${Shopify.routes.root}cart`;
            }
            try {
                const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();      
                if (addWrapResp != null || this._gift_wrapper_id != null){
                  // console.log('addWrapResp addWrapResp addWrapResp addWrapResp addWrapResp addWrapResp >>>>>> ', compProPrice, cartContent);
                  cartContent["sections"] = this.updatePriceInCartDraw(responseJson, true, compProPrice); //responseJson["sections"]
                  //cartContent["wrapper-section"] = addWrapResp["sections"];
                  // console.log('>>>>> _________ updatePriceInCartDraw ', cartContent);
                }else if(compProPrice != null){
                  // console.log('compProPrice compProPrice compProPrice compProPrice compProPrice compProPrice');                  
                  cartContent["sections"] = this.updatePriceInCartDraw(responseJson, false, compProPrice); //responseJson["sections"]
                }else{
                  cartContent["sections"] = responseJson["sections"];
                }
                // console.log('>>>> After updatePriceInCartDraw called .................................');
                this.frm.dispatchEvent(new CustomEvent("variant:add", {
                  bubbles: true,
                  detail: {
                    items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                    //wrapper : addWrapResp.hasOwnProperty("items") ? addWrapResp["items"] : [addWrapResp],
                    cart: cartContent
                  }
                }));
                try {
                    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                      bubbles: true,
                      detail: {
                        baseEvent: "variant:add",
                        cart: cartContent
                      }
                    }));
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                } catch (error) {
                    //console.log('cart:change event Error ! ', error);
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    //window.location.reload();
                }
                  //window.location.reload();
              } catch (error) {
                  console.log('Error! Cart content update Failed....', error);
              }
        } else {
            console.log('Error ------- responseJson is null -----');
        }
        return false;
    }

    async delay(time=1000) {
      return new Promise(resolve => setTimeout(resolve, time));
    }
    
    async waitAWhile(){
      // console.log('start timer waitAWhile ');
      let delay = await this.delay(1000);
      // console.log('waitAWhile after 1 second');
      return delay;
    }

    async addComplementaryProduct(){
        // console.log('>>>>>>>>>>>>>>>> start addComplementaryProduct ');
        let delay = false;
        let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
        if(prc != null && prc != 'undefined'){
            let addcp = prc.querySelector('.custom-checkbox');
            if (addcp.checked) {
                let btnhcp = prc.querySelector('.btn_hcp');
                btnhcp.click();
                delay = await this.waitAWhile();
            }
        }
        return delay;
    } 
    
    updatePriceInCartDraw(responseJson, gwrap=false, compProPrice=null){
      let wqty = this.mainQuantity();
      // main product price then multiply by quantity
      let pcnt = document.querySelector('.product-info__price');
      let mpText = pcnt.querySelector('sale-price').lastChild.textContent;
      let vidPrice = multiplyWithCurrency(mpText, wqty);
      let updatePriceText = vidPrice;
      
      // Gift wrapper price then multiply by quqntity
      if(gwrap != false){
        let gwpText = document.querySelector('.gift-wrapper-price').innerHTML;  // + $ 
        let wprice = multiplyWithCurrency(gwpText, wqty);; //parseFloat(gwpText.replace('+ $','')) * wqty;
        if(wprice && wprice != 'NaN'){
          updatePriceText = vidPrice + ' + ' + wprice;
          // console.log("updatePriceInCartDraw Gift Wrap --------------- ", gwpText, ' || ', wprice, ' || ',  updatePriceText);
        }else{
          console.log('Error! Unable to resolve the Giftwrapper price to Display in Cart Drawer.');
        }
      }
      if(compProPrice != null){
        compProPrice = multiplyWithCurrency(compProPrice, wqty);
        updatePriceText = updatePriceText + ' + ' + compProPrice;
      }
      // console.log("Prices IN updatePriceInCartDraw --------------- ", gwrap, compProPrice, ' || ', mpText, vidPrice, updatePriceText);
      
      let variantAdded = responseJson["sections"]['variant-added'];
      let variantAddedUp = variantAdded.replace(vidPrice, updatePriceText);
      responseJson["sections"]['variant-added'] = variantAddedUp;
      // console.log("responseJson[sections] :: updatePriceInCartDraw --------------- ", responseJson["sections"]);
      return responseJson["sections"];
    }
  
    mainQuantity(){
        // console.log("IN mainQuantity mainQuantity mainQuantity --------------- ");
        let qty = 1;
        let mp_pty = document.querySelector('input[name="quantity"][is="quantity-input"]');
        //console.log('>>>> IN mainQuantity mp_pty ' , mp_pty);
        if(mp_pty && mp_pty != null){
          qty = parseInt(mp_pty.value);
          if(qty == null || qty == 0 || qty == 'NaN'){
              let pfrm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
              // console.log('>>>> IN mainQuantity pfrm ' , pfrm);
              qty = parseInt(pfrm.quantity.value);
          }
        }
        if(qty == null || qty == 0 || qty == 'NaN'){
          qty = 1;
        }
        // console.log('>>>> Out mainQuantity qty ' , qty);
        return qty;
    }
  
    confirmVariant(){
      let pfrm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
      if((pfrm != null && pfrm != 'undefined') && (pfrm.id.value == '' || pfrm.id.value == null)){
          // console.log('_onSubmit ----------------- ', pfrm);
          selMainVarFirstAlert();
          return false;
      }else{
        return true;
      }
    }
}

class RegisterProductFormFallBack {

    async delay(time=1000) {
      return new Promise(resolve => setTimeout(resolve, time));
    }
    
    async waitAWhile(time=1000){
      console.log('start timer waitAWhile ');
      let delay = await this.delay(time);
      console.log('waitAWhile after milli second'+ time);
      return true;
    }

    async confirmFailStatusAndReg(){
        let doSleep = false;
        console.log("Init registerProductFormCompFallBack");
        doSleep = await this.waitAWhile(2000);
        console.log("Check Status to call registerProductFormCompFallBack -- Sleep Done :  "+ doSleep + " -- ProductFormRegistered status now : " + ProductFormRegistered);
        if(doSleep && ProductFormRegistered == false){
            this.registerProductFormExt();
        }
    }

    async registerProductFormExt(){
        console.log("---- registerProductFormExt ---- ");
        if(ProductFormRegistered != true && window.themeVariables.settings.pageType == 'product'){
            if (!window.customElements.get("product-form-extended")) {
                window.customElements.define("product-form-extended", ProductFormExt, { extends: "form" });
            }

            let pfrm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
            console.log('ProductFormBundle connectedCallback Failed ',  pfrm);
            if(pfrm){
              var pfbObj = new ProductFormExt();
              console.log('ProductFormExt manually called  ', pfbObj, pfrm);
              alert('ProductFormExt manually called  ', pfbObj, pfrm);
            }
        }
    }
}

if (window.customElements.get("product-form-bundle")){
    console.log("Window : SUCCESS >>>> product-form-bundle custom element is Registered.", ProductFormRegistered);

    if(ProductFormRegistered != true && window.themeVariables.settings.pageType == 'product'){
        console.log('Proceed To Register FallBack on ProductFormBundle Failed Registeration!');
        const RegFallBack = new RegisterProductFormFallBack();
        let regIfNot = RegFallBack.confirmFailStatusAndReg();
    }

    // Safari, iOS latest update load the main componenet besides with the following fallback causing duplicate addtocart cta.
    /*
    if (!window.customElements.get("product-form-extended")) {
      window.customElements.define("product-form-extended", ProductFormExt, { extends: "form" });
    }
    if(ProductFormRegistered != true && window.themeVariables.settings.pageType == 'product'){
        let pfrm = document.querySelector("form[is='product-form-bundle'][class='shopify-product-form']");
        //console.log('ProductFormBundle connectedCallback Failed ',  pfrm);
        if(pfrm){
          var pfbObj = new ProductFormExt();
          console.log('ProductFormExt manually called  ', pfbObj, pfrm);
          alert('ProductFormExt manually called  ', pfbObj, pfrm);
          //var pfbObj = new ProductFormBundle();
          //console.log('ProductFormBundle manually called  ', pfbObj, pfrm);
        }
    }
    // */
}else{
    console.log( " WARNING ------ product-form-bundle  custom element is NOT Registered." );
    alert(" WARNING ------ product-form-bundle  custom element is NOT Registered." );
}

// js/sections/product-recommendations.js
var ProductRecommendationsExt = class extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }
  connectedCallback() {
    //this.addEventListener("variant:change", this._onMainVariantChange.bind(this));
    this._loadRecommendations();
  }
  disconnectedCallback() {
    let hcps = document.querySelectorAll('.cbx_hcp');
    if(hcps && hcps != null && hcps.length > 0){
      // console.log('Associated Products Loaded ', hcps.length);
      hcps.forEach(hcp => {
        // console.log('Remove Event for Associated Product ', hcp.getAttribute('handle'), hcp);
        hcp.removeEventListener("change", this._productSelectionChangedEvent);
      });
    }
  }

  _onMainVariantChange(event){
    // console.log('-- _onMainVariantChange --------------------------', event.target);
  }
  
  async _loadRecommendations() {
    if (this._isLoaded) {
      return;
    }
    this._enableInputOnLoad = true;
    this._isLoaded = true;
    const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${section.id.replace("shopify-section-", "")}&intent=${intent}`, response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("product-recommendations-ext");
    let pre = productRecommendationsElement;
    this._mainProduct = await ProductLoader.load(this.mainProductHandle);
    //this._mainForm = document.forms[this.getAttribute("form")];
    this._masterSelector = document.forms[this.getAttribute("form")].id;
    // console.log(" ProductRecommendationsExt >>  productRecommendationsElement ", productRecommendationsElement);
    if (productRecommendationsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
      // console.log('_loadRecommendations -- Associated Products Loaded ', productRecommendationsElement.childElementCount);
      if(this._enableInputOnLoad){
        this._registerAssociatedPersonalisationFieldEvent();
      }
      this._registerAssociatedProductEvents(productRecommendationsElement);
    } else {
      if (intent === "related") {
        section.remove();
      } else {
        this.remove();
      }
    }
  }

  _registerAssociatedProductEvents(prExt){      
      // console.log('>>>> Register Associated Product Events ----------------- ');
      let disableInputs = this._enableInputOnLoad?false:true;
      let hcps = document.querySelectorAll('.cbx_hcp');
      if(hcps && hcps != null && hcps.length > 0){
          // console.log('Associated Products Loaded ', hcps.length);
          hcps.forEach(hcp => {
              //console.log('Register Event for Associated Product ', hcp.getAttribute('handle'), hcp);
              if(disableInputs){
                let hdl = hcp.getAttribute("handle");
                let personalisation = hcp.getAttribute('personalisation');
                if(personalisation == "true" || personalisation == true){
                    let plip = document.querySelector('input[plip="'+hdl+'"]');
                    plip.disabled = true;
                    plip.style.backgroundColor = "#d3d3d3";
                }
              }
              hcp.addEventListener("change", this._productSelectionChangedEvent.bind(this));
          });
      }else{
          //console.log('Ooooops ------ Associated Products Yet Not Loaded ', hcps.length);
      }
  }

  _productSelectionChangedEvent(event){
    //console.log("Associated Product Selection Changed.", event.target.checked, event.target);
    this._togglePersonalisationField(event.target);
    this._recalculateAfterPayPalInstallments(event.target);
  }
  
  _recalculateAfterPayPalInstallments(target){
    // console.log('>>>> recalculateAfterPayPalInstallments for Associated Product ----------------- ', target);
    let variant = this._getVariantById(parseInt(this._masterSelector.value));
    if (typeof popCustomPayment === "function"){
      popCustomPayment(variant, 'option1', 100, 'AssociatedProduct');
    }
  }

  _togglePersonalisationField(target){
      // console.log('>>>> _togglePersonalisationField for Associated Product ----------------- ', target.checked, target);
      let hdl = target.getAttribute("handle");
      let personalisation = target.getAttribute('personalisation');
      if(personalisation == "true" || personalisation == true){
        let plip = document.querySelector('input[plip="'+hdl+'"]');
        if(target.checked){
          plip.style.backgroundColor = "";
          plip.disabled = false; // Disable input
        }else{
          plip.style.backgroundColor = "#d3d3d3"; 
          plip.disabled = true; // Disable input
        }
      }
  }

  _registerAssociatedPersonalisationFieldEvent(){
      //console.log('>>>> Register Associated Product Personalisation Fields Events ----------------- ');
      let hcps = document.querySelectorAll('.asso_lip_flag');
      if(hcps && hcps != null && hcps.length > 0){
          //console.log('_registerAssociatedPersonalisationFieldEvent -- Associated Products Loaded ', hcps.length);
          hcps.forEach(hcp => {
              //console.log('_registerAssociatedPersonalisationFieldEvent -- Register Event for Associated Product Personalisation Fields ', hcp.getAttribute('plip'), hcp);
              hcp.addEventListener("input", this._captureAssociatedPersonalisation.bind(this));
          });
      }else{
          //console.log(' _registerAssociatedPersonalisationFieldEvent  >>>> Ooooops ------ Associated Products Yet Not Loaded ', hcps.length);
      }
  }

  _captureAssociatedPersonalisation(event){
      let plip = event.target.getAttribute("plip");
      let chkBox = document.querySelector('input[handle="'+plip+'"]');
      const inputValue = event.target.value;
      //console.log("_captureAssociatedPersonalisation -- Associated Personalisation Input Text Changed.",plip, inputValue, chkBox);
      if(inputValue.length > 0){
        chkBox.checked = true;
      }else{
        // TODO... Nothing...
      }
  }
  
  _getVariantById(id) {
    return this._mainProduct["variants"].find((variant) => variant["id"] === id);
  }

  get mainProductHandle() {
    return this.getAttribute("master-handle");
  }
  
};
if (!window.customElements.get("product-recommendations-ext")) {
  window.customElements.define("product-recommendations-ext", ProductRecommendationsExt);
}


// --
// js/common/actions/addtocart-custom-button.js
// import { animate, timeline as timeline2, stagger } from "//lilycraft.com.au/cdn/shop/t/37/assets/vendor.min.js?v=68060928108819451641712508411";
var AddToCartCustomButton = class extends CustomButton {
    constructor() {
        super();
        if (this.type === "submit" && this.form) {
            this.addEventListener("click", this._customValidity.bind(this));
        }
      
        //aria-controls="quick-buy-023777973"      
        if(this.type === "button" && (this.getAttribute('page') == 'collection' || this.getAttribute('page') == 'index') && this.getAttribute('aria-controls').includes('quick-buy')){
            this.addEventListener("click", this._customValidity.bind(this));
        }
    }

    delay(time=1000) {
      return new Promise(resolve => setTimeout(resolve, time));
    }
    
    async waitAWhile(){
      // console.log('start timer waitAWhile ');
      let delay = await this.delay(1000);
      // console.log('waitAWhile after 1 second');
      return delay;
    }

    async addComplementaryProduct(){
        // console.log('start addComplementaryProduct ');
        let delay = false;
        let prc = document.querySelector('product-recommendations-ext[intent="complementary"]');
        if(prc && prc != null && prc != 'undefined'){
            let addcp = prc.querySelector('.custom-checkbox');
            if (addcp.checked) {
                let btnhcp = prc.querySelector('.btn_hcp');
                btnhcp.click();
                delay = await this.waitAWhile();
            }
        }
        return delay;
    }
  
    async _customValidity(event){
        let isvalid = fnValidateLegalAcceptanceForm(this);
        // console.log('AddToCartCustomButton::_customValidity ', isvalid) ;
        if(isvalid){
          //const addComplementary = await this.addComplementaryProduct();
          //let waitAWhile = await this.waitAWhile();
          //return true;
        }else{
            let knife = false;
            let inType = this.getAttribute('type');
            let pType = this.getAttribute('page');
            if(inType == "submit" && this.form){
                knife = this.form.querySelector('input[type="hidden"][class="hasKnifeTag"]');
            }else if(inType == 'button' && this.getAttribute('hasKnifeTag')){
                knife = this.getAttribute('hasKnifeTag');
            }
            //console.log('Page Type ', pType, ' Product Contains Knife Tag ', knife);          
            if(!isvalid){
                event.preventDefault();
            }          
            if( (pType == 'collection' || pType == 'index') && knife != false && knife != "false"){
                let ldpm = document.querySelector('.ldpm');
                let overlay = ldpm.querySelector('.overlayLDA');
                let lDModal = ldpm.querySelector('.modalLDA');
                openModalLDa(overlay, lDModal, ldpm);
            }
          return false;
        }
        return isvalid;
    }
  
    _legalDisclaimerContainerObject(target){
        return fnLegalDeisclaimerContainer(target);
    }
  
    _acceptKnifeTerms(target, cntObj){
        return fnAcceptKinifLegalTerms(target, cntObj);
    }
  
    _confirmAge(target, cntObj){
          return fnConfirmAge(target, cntObj);
     }
  
    _validAge(target, cntObj){
        return fnValidAge(target, cntObj);
    }
  
    fn_customValidity(target){
        let isValid = false;
        let cntObj = this._legalDisclaimerContainerObject(this);
        //console.log('Legal Disclaimer Container Object ', cntObj);
        if(cntObj != null && cntObj != 'undefined'){
            const ageDisc = cntObj.querySelector('.klad'); // const ageDisc = document.getElementById('age_disclaimer');
            //let ktAcc = this._acceptKnifeTerms(this, cntObj);
            //let kcAge = this._confirmAge(this, cntObj);
            //let ageLimit = this._validAge(this, cntObj);
            // console.log('ktAcc :', ktAcc, ' kcAge :', kcAge, ' ageLimit :', ageLimit, ' ----- age_disclaimer hidden input  ', ageDisc.value);
            if(ageDisc){
                if(!this._acceptKnifeTerms(this, cntObj) || !this._confirmAge(this, cntObj) || !this._validAge(this, cntObj)){
                    //console.log('Invalid Legal Age Props ');
                    isValid = false;
                }
                else{
                    let ageLimit = cntObj.querySelector('.kldob');
                    ageDisc.value = ageLimit.value;
                    isValid = true;
                }
            }
        }
        return isValid;
    }
  
  
};
if (!window.customElements.get("addtocart-custom-button")) {
  window.customElements.define("addtocart-custom-button", AddToCartCustomButton, { extends: "button" });
}

function fnValidateLegalAcceptanceForm(target){
        let isValid = true;
        let cntObj = fnLegalDeisclaimerContainer(target);
        //console.log('Legal Disclaimer Container Object ', cntObj);
        if(cntObj != null && cntObj != 'undefined'){
            const ageDisc = cntObj.querySelector('.klad'); // const ageDisc = document.getElementById('age_disclaimer');
            if(target.form){
              ageDisc.setAttribute('form', target.form.getAttribute('id'));  
            }else{
              ageDisc.setAttribute('form', false);
              ageDisc.setAttribute('ref', target);
            }
            
            if(ageDisc){
                if(!fnAcceptKinifLegalTerms(target, cntObj) || !fnConfirmAge(target, cntObj) || !fnValidAge(target, cntObj) ){
                    //console.log('Invalid Legal Age Props ');
                    isValid = false;
                }
                else{
                    let ageLimit = cntObj.querySelector('.kldob');
                    ageDisc.value = ageLimit.value;
                    isValid = true;
                }
            }
        }
        return isValid;
}

function fnLegalDeisclaimerContainer(target){
        let cntObj = null;
        let pType = target.getAttribute('page');
        //console.log('AddToCartCustomButton::fnLegalDeisclaimerContainer  >> ',  pType, ' ---- '); // frmId, ' ------ ',  'div[class="legal_disclaimer"][form="'+frmId+'"]'
        if(pType == 'product'){
          let frmId = target.form.getAttribute('id');
          if(target.form.getAttribute('is') == 'product-form' || frmId.includes('quick-buy') ){  //  ||  frmId.strpos 'quick-buy'
            let inProd = target.form.querySelector('input[type="hidden"][name="product-id"]');
            cntObj =  document.querySelector('div[class="legal_disclaimer"][form=""]');
            //console.log(' fnLegalDeisclaimerContainer when Quick Buy Form  -- product:', inProd.value , ' Container ', cntObj);
          }else{
            cntObj =  document.querySelector('.legal_disclaimer');
          }          
        }else if(pType == 'collection' || pType == 'index'){
          //cntObj = target.form.querySelector('.legal_disclaimer');
          //cntObj =  document.querySelector('.legal_disclaimer');
          cntObj =  document.querySelector('div[class="legal_disclaimer"][form="form_id"]');
        }
        return cntObj;
}

function fnAcceptKinifLegalTerms(target, cntObj){
        const ktAcc = cntObj.querySelector('.klta');
        const ktAcc_knifeTerms_wrapper = cntObj.querySelector('.ktAccWrapper'); 
        const ktAcc_errorMsg = cntObj.querySelector('.ktAccErrorMsg'); 
        //console.log(' _acceptKnifeTerms input ktAcc ', ktAcc);
        if(ktAcc && !ktAcc.checked){
            //console.log('ktAcc : ', ktAcc.validity);
            if(ktAcc.validity.valueMissing){
                ktAcc.setCustomValidity("Must Accept The Terms and Conditions");
                ktAcc_knifeTerms_wrapper.classList.add('error');
                ktAcc_errorMsg.textContent = ("Must Accept The Terms and Conditions");
                ktAcc.reportValidity();
                return false;
            }else{
                ktAcc.setCustomValidity("");
                ktAcc.ktAcc_knifeTerms_wrapper.remove('error');
                ktAcc_errorMsg.textContent = ("");
            }
        }else{
             ktAcc.setCustomValidity("");
             ktAcc_knifeTerms_wrapper.classList.remove('error');
             ktAcc_errorMsg.textContent = ("");
        }
        return true;
}

function fnConfirmAge(target, cntObj){
        const kcAge = cntObj.querySelector('.klca'); 
        const ktAge_ageConfirmation_wrapper = cntObj.querySelector('.klcaWrapper'); 
        const ktAge_errorMsg  = cntObj.querySelector('.klcaErrorMsg'); 
        if(kcAge && !kcAge.checked){
            //console.log('kcAge : ', kcAge.validity);
            if(kcAge.validity.valueMissing){
                kcAge.setCustomValidity("Must Confirm your Age is 18 years or Above.");
                ktAge_ageConfirmation_wrapper.classList.add('error');
                ktAge_errorMsg.textContent = ("Must Confirm your Age is 18 years or Above.");
                kcAge.reportValidity();
                return false;
            }else{
                kcAge.setCustomValidity("");
                ktAge_ageConfirmation_wrapper.classList.remove('error');
                ktAge_errorMsg.textContent = ("");
            }
        }else{
            kcAge.setCustomValidity("");
            ktAge_ageConfirmation_wrapper.classList.remove('error');
            ktAge_errorMsg.textContent = ("");
        }
        return true;
}

function fnValidAge(target, cntObj){
      let isValid = false;
      const ageLimit = cntObj.querySelector('.kldob'); // document.getElementById('legal-age-dob');
      const ktAgeLimit_wrapper = cntObj.querySelector('.kldobWrapper'); // document.getElementById('ktAcc_legalAgeDobWrapper');
      const ktAgeLimit_errorMsg = cntObj.querySelector('.kldobErrorMsg'); // document.getElementById('ktAcc_legalAgeDobErrorMsg');
      
      //console.log('ageLimit : ', ageLimit.validity);
      //console.log('age :', ageLimit.value, "  ||  length: ", ageLimit.value.length);
      // return false;
      
      if(ageLimit && ageLimit.value.length > 0){
        if(ageLimit.value == "" || ageLimit.value.length  == 0){
          ageLimit.setCustomValidity("Must Provide your Date of Birth. Thanks.");
          ktAgeLimit_errorMsg.textContent = ("Must Provide your Date of Birth. Thanks.");
        }else if(ageLimit.validity.valueMissing){
          ageLimit.setCustomValidity("Must Provide your Date of Birth. Thanks.");
          ktAgeLimit_errorMsg.textContent = ("Must Provide your Date of Birth. Thanks.");
        }else if(ageLimit.validity.patternMismatch){
          ageLimit.setCustomValidity("Pelase provide date in dd-mm-yyyy format");
          ktAgeLimit_errorMsg.textContent = ("Pelase provide date in dd-mm-yyyy format");
        }else{
            if(ageLimit.value != "" && ageLimit.value.length > 6){
                let legal = validateDOB(ageLimit.value);
                //console.log("DOB is Valid " + legal);
                if(legal === 0){
                  ageLimit.setCustomValidity("Must Provide validated Date of Birth. Thanks.");
                  ktAgeLimit_errorMsg.textContent = ("Must Provide validated Date of Birth. Thanks.");
                }else if(legal === false){
                  ageLimit.setCustomValidity("You are not allowed to purchase this product!");
                  ktAgeLimit_errorMsg.textContent = ("You are not allowed to purchase this product!");
                }else if(legal === true){
                  isValid = true;
                  ageLimit.setCustomValidity("");
                  ktAgeLimit_wrapper.classList.remove('error');
                  ktAgeLimit_errorMsg.textContent = ("");
                }
            }else{
               ageLimit.setCustomValidity("Must Provide your Date of Birth. Thanks.");
               ktAgeLimit_errorMsg.textContent = ("Must Provide your Date of Birth. Thanks.");
            }
        }
        if(!isValid){
          ageLimit.reportValidity();
          ktAgeLimit_wrapper.classList.add('error');
          return false;
        }
      }else{
          ageLimit.setCustomValidity("Must Provide your Date of Birth. Thanks.");
          ktAgeLimit_errorMsg.textContent = ("Must Provide your Date of Birth. Thanks.");
          ageLimit.reportValidity();
          ktAgeLimit_wrapper.classList.add('error');
          return false;
      }
      ktAgeLimit_wrapper.classList.remove('error');
      ktAgeLimit_errorMsg.textContent = ("");
      return isValid;
}

function getDateObj(str, reg) {
    let dateRegex = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
    if(reg){
      dateRegex = reg;
    }
   var m = str.match(dateRegex);
   return (m) ? new Date(m[3], m[2]-1, m[1]) : null;
}

function matchRegPattern(str, reg){
    let dateRegex = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
    if(reg){
      dateRegex = reg;
    }
    return dateRegex.test(str);
}

function parseStrAndGetDateObj(dobString, dateFormat="dd-mm-yyyy"){
    // Parse the input string as a date object
    let parts = dobString.split("-");
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript Date objects
    let year = parseInt(parts[2], 10);
    let dob = new Date(year, month, day);
    return dob;
}

function getMinDOB(minAge=18){
    if(!minAge){
      minAge = 18;
    }
    let currentDate = new Date();
    let minDOB = new Date(currentDate.getFullYear() - minAge, currentDate.getMonth(), currentDate.getDate());
    return minDOB;
}

function validateDOB(dobString) {
  
    var dobRegex =  /^(0[1-9]|[1-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-(\d{4})$/;

    //let dobReg = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
    //let dobDate = getDateObj(dobString);
    //let patternMatched =  matchRegPattern(dobString);
    //let userDOB = parseStrAndGetDateObj(dobString);
    //let minValidDob = getMinDOB();
    //console.log('DOB  str:' dobString, ' -- regexTest:', patternMatched , ' -- DOBObj', dobDate);
    //console.log('minDOB:', minValidDob, ' -- userDOB:', userDOB );
  
    // Check if the input string matches the format
    if (!dobRegex.test(dobString)) {
      //console.log("dobRegex Format Mismatch");
      return 0; // Return false if the format is incorrect
    }
  
    // Parse the input string as a date object
    var parts = dobString.split("-");
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript Date objects
    var year = parseInt(parts[2], 10);
    var dob = new Date(year, month, day);
  
    // Calculate the minimum allowed date (18 years ago from the current date)
    var currentDate = new Date();
    var minDOB = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());
  
    // Check if the parsed date is at least 18 years ago from the current date
    if (dob > minDOB) {
      //console.log("validateDOB Age is less than 18");
      return false; // Return false if the person is under 18 years old
    }
  
    // Return true if the DOB is valid (person is 18 years old or older)
    return true;
}

function formatCurrency(input) {
    if (!input) return "0.00"; // Handle empty or undefined inputs
    const numericValue = input.replace(/[^0-9.]/g, '');
    return numericValue ? parseFloat(numericValue).toFixed(2) : "0.00";
}

function multiplyWithCurrency(input, multiplier) {
    // Remove any leading characters before the currency symbol
    input = input.trim().replace(/^[^$€£₹]*([$€£₹])/, '$1');

    // Extract the numeric value
    const numericValue = parseFloat(input.replace(/[^0-9.]/g, ''));

    // Extract the currency symbol (anything that's not a digit or decimal)
    const currencySymbol = input.replace(/[0-9.]/g, '').trim();

    // Perform multiplication and format the result
    const result = (numericValue * multiplier).toFixed(2);

    // Return the result with the currency symbol
    return `${currencySymbol}${result}`;
}

// --
// js/common/product/gift-wrapper.js
var GiftWrapper = class extends HTMLElement {
  // [FIX-5] Guard against BFCache re-running connectedCallback and duplicating form inputs / listeners
  #initialized = false;
  constructor() {
    super();
    this._inputProp = null;
    this._propGiftWrapper = null;
    this._uncheck = false;
    this._wrapperDiv = null;
    this._selWrap = this.querySelector('input[type="hidden"][name="selected-wrapper"]');
    //this.setGetGiftWrapperPriceNode();
    this._showGiftPrice = document.querySelector('#gift-wrapper-price');
  }

  setGetGiftWrapperPriceNode(){
      let cnfNode = document.querySelector('#gift-wrapper-price');
      if(cnfNode == null || cnfNode == 'undefined'){
          //console.log("gift-wrapper-price Node Not Exists..... ");
          let pcnt = document.querySelector('.product-info__price');
          let mpText = pcnt.querySelector('sale-price');
          const newSpan = document.createElement("span");
          newSpan.id = 'gift-wrapper-price';
          newSpan.className = 'text-lg gift-wrapper-price';
          mpText.insertAdjacentElement("afterend", newSpan);
          cnfNode = document.querySelector('#gift-wrapper-price');
          //console.log("Created Node ", cnfNode);
      }else{
        //console.log("Node  Exists", cnfNode);
      }
  }
  
  async connectedCallback() {
    // [FIX-5] Prevent duplicate listener registration and form-property injection on BFCache restore
    if (this.#initialized) return;
    this.#initialized = true;
    this._abortController = new AbortController();
    this.mainProduct = await ProductLoader.load(this.mainProductHandle);
    this._mainForm = document.forms[this.getAttribute("form")];
    this.masterSelector = document.forms[this.getAttribute("form")].id;    
    const selection = this.querySelectorAll(".single-product");
    selection.forEach(element => {
        if(element.tagName == 'DIV'){
          element.addEventListener('click', this._onWrapperSelect.bind(this));
        }
    });

    this.addEventListener("variant:add", this._onMainVariantAdded.bind(this));
    this.addEventListener("variant:change", this._onMainVariantChange.bind(this));
    this.addEventListener("change", this._onWrapperChanged.bind(this), { signal: this._abortController.signal });    
    this.masterSelector.addEventListener("change", this._onMasterVariantChanged.bind(this), { signal: this._abortController.signal });
    //this._updateDisableSelectors();
    this._addFormProperty();
  }


  disconnectedCallback() {
    this._abortController.abort();
    this.removeEventListener("variant:add", this._onMainVariantAdded.bind(this));
    this.removeEventListener("change", this._onWrapperChanged.bind(this), { signal: this._abortController.signal });    
    this.masterSelector.removeEventListener("change", this._onMasterVariantChanged.bind(this), { signal: this._abortController.signal });
    
  }

  _onMainVariantAdded(event){   
    //console.log('-- --------------------------');
    let selWrap = this.querySelector('input[type="hidden"][name="selected-wrapper"]'); 
    //console.log('Main Product Variant Added ', event.detail, ' || selWrap: ', selWrap.value, ' || mainVariantId: ', this.mainVariantId);
    // this._keepGiftWrapperOnMasterVariantChanged();
  }

  _onMainVariantChange(event){
    console.log('GiftWrapper -- _onMainVariantChange --------------------------', event.target);
  }
  
  get mainProductHandle() {
    return this.getAttribute("master-handle");
  }

  get productHandle() {
    return this.getAttribute("handle");
  }
  
  _getVariantById(id) {
    return this.mainProduct["variants"].find((variant) => variant["id"] === id);
  }

  _unCheckGiftWrapp(vid){
      //console.log('Wrapper is Already Selected ', selWrap.value);
      //console.log(' >>>>>>>>>>>>>>>>>> Un-Select the Gift Wrapper');            
      let irad = this.querySelector('input[type="radio"][name="gwrap"][id="'+vid+'"]');          
      irad.checked = false;
      this._selWrap.value = '';
      this._uncheck = true;
      //console.log('After Unset selected-wrapper value :', selWrap.value, ' -----  Input Radio ',irad.getAttribute("name"), ' Checked : ',  irad.checked);
  }
  
  _onWrapperSelect(event){
    this._wrap = event.target;
    if(event.target.tagName == 'IMG'){
      this._wrap = event.target.parentNode;
    }
    this._wrapperDiv = this._wrap;
    //console.log('-- --------------------- ');
    //console.log('Wrapper Click Event ',this._wrapperDiv.getAttribute("vid"));
    let selWrap = this._selWrap; //this.querySelector('input[type="hidden"][name="selected-wrapper"]');
    let vid = this._wrapperDiv.getAttribute("vid");
    
    if(selWrap.value == '' && this.mainVariantId == null ){
        this._unCheckGiftWrapp(vid);
        selMainVarFirstAlert();
        //console.log('No Main Varinat is Selected Yet');
    }
    else if(selWrap.value == '' ){
        this._uncheck = false;
        //console.log('No Wrapper is Selected Yet', selWrap.value);
    }else{
        //console.log('Wrapper is Selected ', selWrap.value);
        if(vid == selWrap.value){
            this._unCheckGiftWrapp(vid);
            //console.log('Wrapper is Already Selected ', selWrap.value);
            //console.log(' >>>>>>>>>>>>>>>>>> Un-Select the Gift Wrapper');
            /*
            let irad = this.querySelector('input[type="radio"][name="gwrap"][id="'+vid+'"]');          
            irad.checked = false;
            // selWrap.value = '';
            this._selWrap.value = '';
            this._uncheck = true;
            //*/
            //console.log('After Unset selected-wrapper value :', selWrap.value, ' -----  Input Radio ',irad.getAttribute("name"), ' Checked : ',  irad.checked);
        }
    }
    //console.log('_onWrapperSelect Target Title ', this._wrapperDiv.getAttribute("title"), ' -- ', this._wrapperDiv.getAttribute("vid"));
    //console.log('-- --------------------- ');
   // console.log('-- --------------------- ');
  }

  get mainVariantId(){
    let vid = null;
    if(this.masterSelector.value != null && this.masterSelector.value != ''){
      vid = this.masterSelector.value;
    }
    return vid;
  }
  
  _onWrapperChanged(event) {
    //console.log('-- ------------------------- ');
    //console.log('>>> Input Radio Change Event');
    //console.log('_onWrapperChanged [Input Name] ', event.target.name, ' Checked :' , event.target.checked);
    if(this._uncheck){
        event.target.checked = false;
        this._selWrap.value = '';
        this.removeWrapperFromCart(event.target);
        //this.querySelector('input[type="hidden"][name="selected-wrapper"]').value = '';
        //console.log('Uncheck >> _onWrapperChanged [Input Name] ', event.target.name, ' Checked :' , event.target.checked);
    }
    if (!event.target.name.startsWith("gwrap") || this._uncheck || this.mainVariantId == null ) {
      return;
    }
    this.selectWrapper(event.target);
  }
  
  _onMasterVariantChanged(event) {
    let selWrap = this.querySelector('input[type="hidden"][name="selected-wrapper"]');
    //console.log('Main Product Variant Changed ', event.target, ' || selWrap: ', selWrap.value, ' || mainVariantId: ', this.mainVariantId);
    //this._keepGiftWrapperOnMasterVariantChanged();
    this._unSelectGiftWrapperOnMasterVariantChanged();
  }

  _unSelectGiftWrapperOnMasterVariantChanged(){
      let selCnt = 0;
      const radios = document.getElementsByName("gwrap");
      radios.forEach(radio => {
        if(radio.checked == true){
            this._unCheckGiftWrapp(radio.id);
            this.selectWrapper(radio);
            radio.checked = false;
            selCnt = 1;
        }          
      });
    if(selCnt == 0){
      let variant = this._getVariantById(parseInt(this.masterSelector.value));
      if (typeof popCustomPayment === "function"){
        popCustomPayment(variant, 'option1', 100, '_unSelectGiftWrapperOnMasterVariantChanged');
      }
    }
  }
  _keepGiftWrapperOnMasterVariantChanged(){
    let selWrap = this.querySelector('input[type="hidden"][name="selected-wrapper"]');
    if(selWrap.value != '' && selWrap.value != null ){
      //this.setGetGiftWrapperPriceNode(); //
      //this._showGiftPrice = document.querySelector('#gift-wrapper-price');
      let pcnt = document.querySelector('.product-info__price');
      let cnfNode = pcnt.querySelector('#gift-wrapper-price');
      //console.log("let cnfNode ", cnfNode);
      if(cnfNode == null || cnfNode == 'undefined'){
          let newSpan = document.createElement("span");
          newSpan.id = 'gift-wrapper-price';
          newSpan.className = 'text-lg gift-wrapper-price';
          let mpText = pcnt.querySelector('sale-price');
          mpText.insertAdjacentElement("afterend", newSpan);
          cnfNode = pcnt.querySelector('#gift-wrapper-price');
          //console.log("IS cnfNode ", cnfNode);
      }
      if(cnfNode != null){        
        cnfNode.innerHTML = '+ '+ document.querySelector('.gw-list-price').innerHTML;
        this._showGiftPrice = cnfNode;
        //console.log("_onMasterVariantChanged :: GW Price ", cnfNode, document.querySelector('.gw-list-price').innerHTML);
      }else{
        //console.log("Fail to Create and append Node ", cnfNode);
      }
    }
  }
  
  selectWrapper(target){
      if(target.checked == true){
        //console.log('selectWrapper >> ', target.value, 'Input Checked ', target.checked);
        this._selWrap.value = target.value;
        this.addWrapperToCart(target);
        //this.querySelector('input[type="hidden"][name="selected-wrapper"]').value = target.value;
      }else{
        //console.log(target.value, 'Input Not Checked ', target.checked);
        this._selWrap.value = '';
        this.removeWrapperFromCart(target);
        //this.querySelector('input[type="hidden"][name="selected-wrapper"]').value = '';
      }
      //const wraperDiv = this._wrapperDiv; //this.querySelector('.single-product.gwrap-'+target.value);
      //console.log(' >>>> Wrapper Div border-color  ', wraperDiv.style.borderColor, ' ----- Div Title --',  wraperDiv.getAttribute("title") );
  }

  addWrapperToCart(wrapElm){
    //this.setGetGiftWrapperPriceNode(); //
    this._showGiftPrice = document.querySelector('#gift-wrapper-price');
    //let giftFormatedPrice = document.createRange().createContextualFragment(formatMoney(wrapElm.getAttribute('price'), currencyFormat));
    this._showGiftPrice.innerHTML = '+ '+ document.querySelector('.gw-list-price').innerHTML; //giftFormatedPrice; //wrapElm.getAttribute('price');
    //console.log("addWrapperToCart >> showGiftPrice.innerHTML : ", this._showGiftPrice.innerHTML);
    let variant = this._getVariantById(parseInt(this.masterSelector.value));
    //this._inputProp.value = wrapElm.getAttribute('title');
    this._propGiftWrapper.value = wrapElm.getAttribute('title');
    //console.log('addWrapperToCart  wrapper id : ', wrapElm.value, '  -- price : ', variant.price);
    if (typeof popCustomPayment === "function"){
      popCustomPayment(variant, 'option1', 100, 'addWrapperToCart');
    }
  }

  removeWrapperFromCart(wrapElm){
    //this._inputProp.value = null;
    this._propGiftWrapper.value = null;
    this._showGiftPrice.innerHTML = '';    
    if(this.mainVariantId){
      let variant = this._getVariantById(parseInt(this.masterSelector.value));
      if (typeof popCustomPayment === "function"){
        popCustomPayment(variant, 'option1', 100, 'removeWrapperFromCart');
      }
    }
  }

  _addFormProperty(){
      let inputPropName = 'properties[_'+this.productHandle+']';    
      const newInput = document.createElement("input");
      newInput.type = 'hidden';
      newInput.name = inputPropName;
      newInput.id = "prop-"+this.productHandle;
        
      const clone = newInput.cloneNode();
      clone.id = 'has_gift_wrap';
      clone.setAttribute('name', 'properties[Gift Wrapper]');
    
      //this._mainForm.appendChild(newInput);
      this._mainForm.appendChild(clone);
    
      //this._inputProp = document.querySelector('input[name="'+inputPropName+'"]');
      this._propGiftWrapper = document.querySelector('input[name="properties[Gift Wrapper]"]');
  }
  
  _getMainVariant(){    
    let vid = parseInt(wrapElm.value);
    let variant = this._getVariantById(parseInt(this.masterSelector.value));
  }
}
if (!window.customElements.get("gift-wrapper")) {
  window.customElements.define("gift-wrapper", GiftWrapper);
}

// --
// js/common/product/line-item-update.js
var LineItemUpdate = class extends LineItemQuantity {
  constructor() {
    super();
    this._lineItem = 'line-item-update'; // 'line-item'
  }
  
  async _onQuantityChanged(event) {
    if (!event.target.hasAttribute("data-line-key")) {
      return;
    }
    if(parseInt(event.target.value) == 0 && event.target.getAttribute("_for") != "" && event.target.getAttribute("_for") != null){
      this._mainRef = this.querySelector('a[data-line-id="'+event.target.getAttribute("_for")+'"]');
      if(this._mainRef != null && this._mainRef != ""){
        //console.log ('Main Variant Line Item Key', this._mainRef.hasAttribute("data-line-key"));
        //let wait = await this._updatePropertiesOff(event.target);
      }
    }
    this._changeLineItemQuantity(event.target.getAttribute("data-line-key"), parseInt(event.target.value));
  }
  
  async _onRemoveLinkClicked(event) {
    //console.log('----- _onRemoveLinkClicked >> tagName : ', event.target.tagName, ' ||  href ;', event.target.href);
    if (event.target.tagName !== "A" || !event.target.href.includes("/cart/change")) {
      return;
    }
    //console.log('_onRemoveLinkClicked > pageType : ', window.themeVariables.settings.pageType);
    event.preventDefault();
    const url = new URL(event.target.href);
    event.target.href = 'javascript:;';

    let letGo = false;
    if(event.target.getAttribute("_for") != "" && event.target.getAttribute("_for") != null){
      letGo = await this._updatePropertiesOff(event.target, "_for");
    }else if(event.target.getAttribute("_associated") != "" && event.target.getAttribute("_associated") != null){
      letGo = await this._updatePropertiesOff(event.target, "_associated");
    }else if(event.target.getAttribute("_has") != "" && event.target.getAttribute("_has") != null){
      letGo = await this._removeGiftWrap(event.target);
    }else{
      console.log('No Side Item Linking Found '); //console.log('_for is null ', event.target.getAttribute("_for"));
    }

    //console.log('LineItemUpdate:: _onRemoveLinkClicked wait to continue ', letGo , ' >> lineKey : ', url.searchParams.get("id"),' -- targetQuantity : ', parseInt(url.searchParams.get("quantity")));
    if (window.themeVariables.settings.pageType === "cart") {
       //console.log('_onRemoveLinkClicked when pageType is cart ');
      //return false;
      window.location.href = `${Shopify.routes.root}cart/change?id=${url.searchParams.get("id")}&quantity=${parseInt(url.searchParams.get("quantity"))}`;
    }else{
      //console.log('_onRemoveLinkClicked when pageType IS NOT cart ');
      let changeQ = await this._changeLineItemQuantity(url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")));    
    }
    return false;
  }
  
  async _changeLineItemQuantity(lineKey, targetQuantity) {
    //console.log(" LineItemUpdate :: _changeLineItemQuantity [lineKey, targetQuantity]", lineKey, targetQuantity);
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
    } else {
      //const lineItem = this.closest("line-item");
      const lineItem = this.closest(this._lineItem);
      //console.log(" LineItemUpdate :: _changeLineItemQuantity  lineItem : this.closest(this._lineItem)", lineItem);
      //lineItem?.dispatchEvent(new CustomEvent(this._lineItem+":will-change", { bubbles: true, detail: { targetQuantity } }));
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          // sections: ["cart-drawer"], // V 2.4.1
          sections: sectionsToBundle    // V 6.4.0
        })
      })).json();
      //*
      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      let qtyAfterchange = lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"];
      //console.log("LineItemUpdate :: _changeLineItemQuantity [ qtyAfterchange, lineItemAfterChange.length, lineItemAfterChange ]", qtyAfterchange, lineItemAfterChange.length, lineItemAfterChange);
      // lineItem?.dispatchEvent(new CustomEvent(this._lineItem+":change", {
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          //baseEvent: this._lineItem+":change",
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
      // */
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    return true;
  }

  async _updatePropertiesOff(targetElm, propName){
      let done = null;
      let variant_id = targetElm.getAttribute(propName);//("_for");
      this._mainRef = document.querySelector('a[data-line-id="'+variant_id+'"]');
      //console.log ('LineItemUpdate :: _updatePropertiesOff [targetElm, propName, this._mainRef] ', targetElm, propName, this._mainRef);
      if(this._mainRef != null && this._mainRef != ""){
          done = await this._updateLineItemProperties(this._mainRef, targetElm, propName);
      }
    return done;
  }
  async _updateLineItemProperties(mainRef, targetElm, propName){
      const lineKey = mainRef.getAttribute("data-line-key");
      const properties = this._propAfterGiftWrap(mainRef.getAttribute("data-line-id"), propName);
      const lineItem = document.querySelector('line-item[line-key="'+lineKey+'"]');
      let mainQtyelem = document.querySelector("input[is='quantity-input'][data-line-key='"+lineKey+"']");
      let mainQty = mainQtyelem.value || 1;
      //console.log ('Main Variant Line Item Key', lineKey);
      //console.log('update properties of ', lineKey, ' --- Props : ',properties);
      //console.log("_updateLineItemProperties [mainRef, targetElm, propName]", mainRef, targetElm, propName);
      //console.log("_updateLineItemProperties [lineKey, lineItem, properties]", lineKey, lineItem, properties);
      //*
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { properties } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: mainQty,
          properties: properties,
          sections: sectionsToBundle    // V 6.4.0
        })
      })).json();
      //*
      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
       //console.log('_updateLineItemProperties >> lineItemAfterChange ', lineItemAfterChange);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          properties: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["properties"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
      //*/
       //console.log('_updateLineItemProperties >> cartContent ', cartContent);
      return true;
  }
  
  _propAfterGiftWrap(variant_id, propName){
    let props = {};
    const allProps = document.querySelectorAll('input[id="pp-'+variant_id+'"]');
    //console.log("_propAfterGiftWrap ----- [variant_id, propName, allProps] ", variant_id, propName, allProps);
    //console.log('_propAfterGiftWrap >> variant_id : ', variant_id , ' || allProps : ', allProps,  'input[id="pp-'+variant_id+'"]');
    const propStartWith = "Add ons";
    allProps.forEach(prop => {
        let propVal = prop.value;
        //console.log('_propAfterGiftWrap >> prop.name : ', prop.name, ' ||  prop.value: ', prop.value);
        if(propName == "_associated" && prop.name.startsWith(propStartWith)){
            propVal = null;
        }else if(propName == "_for" && (prop.name == 'Gift Wrapper' || prop.name == '_gift-wrap')){
            propVal = null;
        }
        if(propName == "_for"){
          if(prop.name != '_has'){
            props[prop.name] = propVal;
          }
        }else{
          props[prop.name] = propVal;
        }
    });
    //console.log("EOF _propAfterGiftWrap ----- [allProps -- updated] ", props);
    return props;
  }

  async _removeGiftWrap(variantElm){
       //console.log('_removeGiftWrap --- variantElm ---', variantElm)
      let wait = false;
      this._giftWrap = document.querySelector('a[data-line-id="'+variantElm.getAttribute("_has")+'"]');
      if(this._giftWrap != null && this._giftWrap != ""){
        let url = new URL(this._giftWrap);
        let dlk = this._giftWrap.getAttribute("data-line-key");
        let lineKey = url.searchParams.get("id");
        let targetQuantity = parseInt(url.searchParams.get("quantity"));
         //console.log ('Removable -- Gift Wrapper Line Item : ', dlk, lineKey, targetQuantity , ' >> ', this._giftWrap);        
        let lineItem = this._giftWrap.closest("line-item-update");
         //console.log(' --- Side GW lineItem ---', lineItem)
        wait  = await this._removeLinkedSideLineItem(this._giftWrap, lineKey, targetQuantity);
      }
      return wait;
  }

  async _removeLinkedSideLineItem(sideItemLink, lineKey, targetQuantity){
      let lineItem = sideItemLink.closest("line-item-update");
       //console.log('_removeLinkedSideLineItem --- Side GW lineItem ---', lineItem);
      lineItem?.dispatchEvent(new CustomEvent(this._lineItem+":will-change", { bubbles: true, detail: { targetQuantity } }));
      let cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: ["cart-drawer"]
        })
      })).json();
      let lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      if(lineItem){
        lineItem?.dispatchEvent(new CustomEvent(this._lineItem+":change", {
          bubbles: true,
          detail: {
            quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: this._lineItem+":change",
            cart: cartContent
          }
        }));
      }
      return lineItemAfterChange;    
  }
  
}
if (!window.customElements.get("line-item-update")) {
  window.customElements.define("line-item-update", LineItemUpdate);
}

// --
// js/common/product/buy-buttons-shop-pay.js
var BuyButtonsShopPay = class extends BuyButtons {
   constructor() {
    super();
    this._observer = null;
    this._productForm = document.forms[this.getAttribute("form")];
    //this._onShopPayClickListener = this._whenBuyWithShopPay.bind(this);
    this._selWrap = document.querySelector('input[type="hidden"][name="selected-wrapper"]');
  }
  connectedCallback() {
    //this._dynamicBtnObserver();
    this.querySelector('.shopify-payment-button').addEventListener("click", this._registerBuyWithShopPayClick.bind(this));
    this._paymentButton = this.querySelector('div[role="button"][data-testid="ShopifyPay-button"]'); 
    if(this._paymentButton != null){
      this._paymentButton.addEventListener("click", this._buyWithQuickCheckOut.bind(this));
    }
  }
  disconnectedCallback() {
    this.querySelector('.shopify-payment-button').removeEventListener("click", this._registerBuyWithShopPayClick.bind(this));
    if(this._paymentButton != null){
      this._paymentButton.removeEventListener("click", this._buyWithQuickCheckOut.bind(this));
    }
  }
  
  _dynamicBtnObserver(){
    let btnContainer = this.querySelector('.shopify-payment-button');
    // create an observer instance
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            console.log(mutation.type, mutation);
        });
    });
    // configuration of the observer:
    var config = { attributes: true, childList: true, characterData: true }

    // pass in the target node, as well as the observer options
    observer.observe(btnContainer, config);
  }
  
  _whenBuyWithShopPay(event){
    this._selWrap = document.querySelector('input[type="hidden"][name="selected-wrapper"]');
    //console.log('selected Wrap ', this._selWrap);
    if(this._selWrap != null && this._selWrap.value != null && this._selWrap.value != ""){
        var iid = this._productForm.querySelector('input[name="id"]');    
        iid.setAttribute('data-val', 'main');
        iid.setAttribute('type',  'hidden');
        iid.setAttribute('name', 'id[]');
        
        let clone = iid.cloneNode();
        clone.setAttribute('data-val', 'wrap');
        clone.value = this._selWrap.value
        clone.setAttribute('value', this._selWrap.value);
        this._productForm.appendChild(clone);
    }
  }

 async _addGiftWrapperToCart(){
      let responseJson = null;
      let selWrap = document.querySelector('input[type="hidden"][name="selected-wrapper"]');
      if(selWrap != null && selWrap != "" && selWrap.value != ""){
          let formData = new FormData();
          formData.append('id', selWrap.value);
          formData.append('quantity', 1);
          formData.append('utf8', true);
          formData.set("sections", "cart-drawer,variant-added");
          formData.set("sections_url", `${Shopify.routes.root}variants/${selWrap.value}`);
          const gwResp = fetch(`${Shopify.routes.root}cart/add.js`, {
            body: formData,
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });
          responseJson = await gwResp.json();
          //console.log('Gift Wrapper Added to Cart ', responseJson);
      }
      return responseJson;
  }
  
  async _registerBuyWithShopPayClick(event){
    //this._whenBuyWithShopPay();
    //this._addGiftWrapperToCart(event);
    this._paymentButton = this.querySelector('div[role="button"][data-testid="ShopifyPay-button"]'); 
    this._paymentButton.addEventListener("click", this._buyWithQuickCheckOut.bind(this));
    /*
    this._paymentButton.style.disabled = true;
    //console.log('shopify-payment-button click ');
    if(!confirm('Then Gift Wrapper option not available with quick checkout')){
      return false;
    }
    //console.log('Wrapper Added to Cart', resp);
    if(!confirm('Are you sure to continue with Quick Pay! Then Gift Wrapper will not be included')){
      return false;
    }
    //*/
  }

  _buyWithQuickCheckOut(event){
    //let cnf = confirm('Confirm Quick Checkout ');
  }
}
if (!window.customElements.get("buy-buttons-shop-pay")) {
  window.customElements.define("buy-buttons-shop-pay", BuyButtonsShopPay);
}

// Export Components
export {
  VariantPickerPaymnet,
  ProductFormBundle,
  GiftWrapper,
  LineItemUpdate,
  BuyButtonsShopPay,
  ProductRecommendationsExt
};